import type { DoorConfig } from '@/lib/configurator/options'

export type GlassLook = 'helder' | 'mat' | 'ribbel' | 'rook' | 'brons' | 'neutraal'

export const glassLook = (config: Pick<DoorConfig, 'glass' | 'glassNote'>): GlassLook => {
    if (config.glass === 'helder') return 'helder'
    if (config.glass === 'mat') return 'mat'

    const wish = (config.glassNote ?? '').toLowerCase()

    if (/ribbel|riet|fluted|kathedraal/.test(wish)) return 'ribbel'
    if (/rook|grijs|grey|gray|zwart/.test(wish)) return 'rook'
    if (/brons|goud|amber|bruin/.test(wish)) return 'brons'
    if (/mat|satijn|melk|zuur/.test(wish)) return 'mat'

    return 'neutraal'
}

export const GLASS_LOOK_FILL: Record<GlassLook, string> = {
    helder: '#dfe9e6',
    mat: '#eef0f0',
    ribbel: '#d9e4e1',
    rook: '#5f6366',
    brons: '#8a6d4f',
    neutraal: '#d4dddd'
}
